module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_6005.3de0ed6d.png";